import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { pick } from 'ramda'

import { breakpoints } from '@/styles'
import { initializeApollo } from '@/lib/apollo'
import { getCityAndNeighborhoodData } from '@/lib/locations'
import { initializeStore } from '@/lib/redux'
import { getSession } from '@/lib/session'
import { makeMainLayout } from '@/layouts/main'
import ListingsMap from '@/features/ListingsMap'
import { getIsMobile } from '@/components/use-is-mobile'

const headerConfig = {
  showSearch: true
}
const footerConfig = {
  hideOnBreakpoint: breakpoints.ipadMiniMax,
  hideOnMobile: true
}
const supportConfig = {
  enabled: false
}

const selectFromState = pick(['listings', 'session'])

const MapComponent = ({ isMobile }) => {
  return <ListingsMap initialListVisible={isMobile} />
}

// This route handles several possible URL combinations:
// - City page - /city/vancouver
// - City page with filter - /city/vancouver/1-bedroom
// - Neighborhood/university/poi page - /city/vancouver/ubc
// - Neighborhood/university/poi page with filter - /city/vancouver/ubc/1-bedroom
// The majority of the logic to handle these URLs is in src/utils/location.js

export const getServerSideProps = async ({ req, query, locale }) => {
  const apolloClient = initializeApollo()
  const reduxStore = initializeStore()
  const userAgent = req.headers['user-agent']
  const isMobile = getIsMobile(userAgent)
  const [{ cityData, neighborhoodData }] = await Promise.all([
    getCityAndNeighborhoodData({
      reduxStore,
      apolloClient,
      query,
      req
    }),
    getSession({ req, reduxStore })
  ])

  const cityTranslations = cityData.slug ? [`seo.city.${cityData.slug}`] : []
  const neighborhoodTranslations = neighborhoodData.slug?.slug_name
    ? [
        `seo.hood.${neighborhoodData.slug.slug_name}-${neighborhoodData.slug.slug_city}`
      ]
    : []
  const poiTranslations = neighborhoodData.type === 'poi' ? [`seo.pois`] : []

  return {
    props: {
      isMobile: isMobile,
      initialApolloState: apolloClient.cache.extract(),
      initialReduxState: selectFromState(reduxStore.getState()),
      ...(await serverSideTranslations(locale, [
        'translation',
        'seo',
        'states',
        'cities',
        'filters',
        ...cityTranslations,
        ...neighborhoodTranslations,
        ...poiTranslations
      ]))
    }
  }
}

MapComponent.Layout = makeMainLayout({
  headerConfig,
  footerConfig,
  supportConfig,
  disableZoom: true
})

export default MapComponent
